module.exports = __webpack_public_path__ + "img/arrow-right.c1e42ed5.svg";